// assets/subscription-swap.js
import { CartAddEvent } from '@theme/events';

document.addEventListener(CartAddEvent.eventName, async (event) => {
  // Only react to real PDP/product-form adds, not internal cart updates
  if (event.detail?.data?.source !== 'product-form-component') return;

  const addedVariantId = event.detail.sourceId;
  if (!addedVariantId) return;

  const cart = await fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json());

  const addedIndex = cart.items.findIndex((i) => i.variant_id.toString() === addedVariantId);
  if (addedIndex === -1) return;

  const addedItem = cart.items[addedIndex];
  const isSubscription = !!addedItem.selling_plan_allocation;

  // Same variant, opposite purchase type (one-time vs subscription)
  const dupIndex = cart.items.findIndex(
    (i, idx) =>
      idx !== addedIndex &&
      i.variant_id.toString() === addedVariantId &&
      !!i.selling_plan_allocation !== isSubscription
  );

  if (dupIndex === -1) return;

  const cartItemsComponent = document.querySelector('cart-items-component');
  if (!cartItemsComponent) return;

  cartItemsComponent.updateQuantity({
    line: dupIndex + 1, // Shopify cart lines are 1-indexed
    quantity: 0,
    action: 'clear',
  });
});